export default __webpack_public_path__ + "static/single-step-light-8ab1308e542b50c742abf0ea3130a799.png";